/**
 * @desc 获取供应商整体列表信息
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: defs.srm.SupplierInfoRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/srm/supplierInfo/List`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
